<div class="toggle-container">
    <div *ngIf="label"
        class="label default">
        {{label}}
    </div>
    <input type="checkbox" class="toggle-input"
    [formControl]="control"
    #checkBox/>
    <label class="toggle-label" [class.initial]="control?.value !== true && control?.value !== false" [class.error]="control?.invalid && control?.touched">
        <span class="toggle-option yes" (click)="yesClicked()">Yes</span>
        <span class="toggle-option no"  (click)="noClicked()">No</span>
    </label>
</div>